"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentDetails = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
// Memoized signer row to prevent re-renders
const SignerRow = (0, react_1.memo)(({ signer, index, onUpdate, onRemove, }) => {
    return (react_1.default.createElement("div", { className: "flex gap-4" },
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", size: "small", value: signer.email, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                    onUpdate(index, "email", e);
                }) })),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "First Name", size: "small", value: signer.first_name, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                    onUpdate(index, "first_name", e);
                }) })),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Last Name", size: "small", value: signer.last_name, borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                    onUpdate(index, "last_name", e);
                }) })),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faMinus, backgroundColor: "bg-white", borderColor: "border-borders", iconColor: "text-black", size: "xsmall", onClick: () => onRemove(index) }))));
}, (prevProps, nextProps) => {
    // Only re-render if the actual signer data changed
    return (prevProps.signer.email === nextProps.signer.email &&
        prevProps.signer.first_name === nextProps.signer.first_name &&
        prevProps.signer.last_name === nextProps.signer.last_name &&
        prevProps.index === nextProps.index);
});
const DocumentDetails = ({ documentInfo, setDocumentInfo }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocument, createFormErrors } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const [onlySigner, setOnlySigner] = (0, react_1.useState)(false);
    const [documentName, setDocumentName] = (0, react_1.useState)("");
    const [signers, setSigners] = (0, react_1.useState)([]);
    const previousSignersRef = (0, react_1.useRef)(documentInfo.signers);
    (0, react_1.useEffect)(() => {
        if (selectedDocument) {
            setDocumentName(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.name);
            setOnlySigner(selectedDocument.only_signer);
            if (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers)
                setSigners(selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers);
        }
    }, [selectedDocument]);
    // useEffect(() => {
    //   if (!documentInfo.only_signer && documentInfo.signers.length === 0) {
    //     setDocumentInfo({
    //       ...documentInfo,
    //       signers: [
    //         {
    //           first_name: "",
    //           last_name: "",
    //           email: "",
    //         },
    //       ],
    //     });
    //   } else {
    //     setDocumentInfo({ ...documentInfo, signers: [] });
    //   }
    // }, [onlySigner]);
    (0, react_1.useEffect)(() => {
        if (documentInfo.only_signer) {
            previousSignersRef.current = documentInfo.signers;
            setDocumentInfo(Object.assign(Object.assign({}, documentInfo), { signers: [] }));
        }
        else {
            setDocumentInfo((prev) => (Object.assign(Object.assign({}, prev), { signers: previousSignersRef.current && previousSignersRef.current.length > 0
                    ? previousSignersRef.current
                    : [
                        {
                            first_name: "",
                            last_name: "",
                            email: "",
                        },
                    ] })));
        }
    }, [documentInfo.only_signer]);
    // Validation removed from useEffect to prevent focus loss on keystroke
    // Validation happens on Save button click in create_document.tsx
    const updateSigners = (0, react_1.useCallback)((index, key, value) => {
        setDocumentInfo((prev) => (Object.assign(Object.assign({}, prev), { signers: prev.signers.map((x, i) => {
                if (index === i) {
                    return Object.assign(Object.assign({}, x), { [key]: value });
                }
                return x;
            }) })));
    }, []);
    const removeSigner = (0, react_1.useCallback)((index) => {
        setDocumentInfo((prev) => (Object.assign(Object.assign({}, prev), { signers: prev.signers.filter((signer, k) => k !== index) })));
    }, []);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 bg-white p-4" },
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: `Document name`, size: "small", value: documentInfo.name, errorText: documentInfo.name ? "" : "Document name is required", borderColor: "border-borders", backgroundColor: "bg-white", onChange: (e) => __awaiter(void 0, void 0, void 0, function* () {
                    setDocumentInfo(Object.assign(Object.assign({}, documentInfo), { name: e }));
                }) })),
        react_1.default.createElement("div", { className: "" },
            react_1.default.createElement(doshx_controls_web_1.CheckboxControl, { label: "I'm the only signer", decorationColor: "decoration-borders", uncheckedColor: "text-textInput", checkedColor: "text-success", value: documentInfo.only_signer, size: "xsmall", textColor: "text-textInput", onChange: (v) => {
                    setDocumentInfo(Object.assign(Object.assign({}, documentInfo), { only_signer: Boolean(v) }));
                } })),
        !documentInfo.only_signer &&
            documentInfo.signers.length > 0 &&
            documentInfo.signers.map((x, index) => (react_1.default.createElement(SignerRow, { key: x._id || `signer-${index}`, signer: x, index: index, onUpdate: updateSigners, onRemove: removeSigner }))),
        !documentInfo.only_signer && (react_1.default.createElement("div", { className: "flex justify-end" },
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faAdd, backgroundColor: "bg-white", borderColor: "border-secondary", iconColor: "text-black", size: "xsmall", onClick: () => {
                        setDocumentInfo(Object.assign(Object.assign({}, documentInfo), { signers: [
                                ...documentInfo.signers,
                                {
                                    first_name: "",
                                    last_name: "",
                                    email: "",
                                },
                            ] }));
                    } }))))));
};
exports.DocumentDetails = DocumentDetails;
